import React from 'react';
import '../styles/LanguageBadges.css';

const LanguageBadges = () => {
  const languages = [
    { code: 'es', name: 'Spanish' },
    { code: 'en', name: 'English' },
    { code: 'hi', name: 'Hindi' },
    { code: 'zh', name: 'Mandarin' },
    { code: 'ar', name: 'Arabic' },
    { code: 'ja', name: 'Japanese' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'ko', name: 'Korean' },
    { code: 'it', name: 'Italian' },
    { code: 'pl', name: 'Polish' },
    { code: 'tr', name: 'Turkish' },
    { code: 'ta', name: 'Tamil' },
  ];

  return (
    <div className="language-badges">
      {languages.map((lang) => (
        <div key={lang.code} className="language-badge">
          <span className="language-code">{lang.code.toUpperCase()}</span>
          <span className="language-name">{lang.name}</span>
        </div>
      ))}
    </div>
  );
};

export default LanguageBadges;
